import angular from 'angular';
import RelatedProductsComponent from './related-products.component';

let RelatedProductsModule = angular.module('catalog.relatedProducts', [])
  .component('relatedProducts', RelatedProductsComponent);

export default RelatedProductsModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/related-products/related-products.js
 **/